"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "motion/react";
import { type CSSProperties, type ElementType, type JSX, memo, useMemo } from "react";
import { cn } from "@/lib/utils";
export interface TextShimmerProps {
  children: string;
  as?: ElementType;
  className?: string;
  duration?: number;
  spread?: number;
}
const ShimmerComponent = t0 => {
  const $ = _c(16);
  const {
    children,
    as: t1,
    className,
    duration: t2,
    spread: t3
  } = t0;
  const Component = t1 === undefined ? "p" : t1;
  const duration = t2 === undefined ? 2 : t2;
  const spread = t3 === undefined ? 2 : t3;
  let t4;
  if ($[0] !== Component) {
    t4 = motion.create(Component as keyof JSX.IntrinsicElements);
    $[0] = Component;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const MotionComponent = t4;
  const dynamicSpread = (children?.length ?? 0) * spread;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      backgroundPosition: "0% center"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== className) {
    t6 = cn("relative inline-block bg-[length:250%_100%,auto] bg-clip-text text-transparent", "[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--color-background),#0000_calc(50%+var(--spread)))] [background-repeat:no-repeat,padding-box]", className);
    $[3] = className;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      backgroundPosition: "100% center"
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = `${dynamicSpread}px`;
  let t9;
  if ($[6] !== t8) {
    t9 = {
      "--spread": t8,
      backgroundImage: "var(--bg), linear-gradient(var(--color-muted-foreground), var(--color-muted-foreground))"
    };
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = t9 as CSSProperties;
  let t11;
  if ($[8] !== duration) {
    t11 = {
      repeat: Number.POSITIVE_INFINITY,
      duration,
      ease: "linear"
    };
    $[8] = duration;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== MotionComponent || $[11] !== children || $[12] !== t10 || $[13] !== t11 || $[14] !== t6) {
    t12 = <MotionComponent animate={t5} className={t6} initial={t7} style={t10} transition={t11}>{children}</MotionComponent>;
    $[10] = MotionComponent;
    $[11] = children;
    $[12] = t10;
    $[13] = t11;
    $[14] = t6;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  return t12;
};
export const Shimmer = memo(ShimmerComponent);